/**
 * Generated runtime TestId mirror for frontend/src/pages/Resources.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ResourcesTestIds = {
  btnNewResource: "btn-new-resource",
  colClassification: "col-classification",
  colName: "col-name",
  colSystem: "col-system",
  colType: "col-type",
  resourcesList: "resources-list",
  linkResourceDetail: (resource_id: string) => `link-resource-detail-${resource_id}`,
  linkResourceDetailPrefix: () => "link-resource-detail-" as TestIdPrefix,
  linkSystemDetail: (resource_targetSystem_id: string) => `link-system-detail-${resource_targetSystem_id}`,
  linkSystemDetailPrefix: () => "link-system-detail-" as TestIdPrefix
} as const;
